// source: acompanha/printer_maintenances/v1/printer_maintenances.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.PrinterMaintenance', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.ReplacementPart', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest', null, global);
goog.exportSymbol('proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.displayName = 'proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.displayName = 'proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest.displayName = 'proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.displayName = 'proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.displayName = 'proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest.displayName = 'proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.displayName = 'proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.displayName = 'proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.ReplacementPart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.ReplacementPart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.ReplacementPart.displayName = 'proto.acompanha.printer_maintenances.v1.ReplacementPart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printer_maintenances.v1.PrinterMaintenance.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.PrinterMaintenance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.PrinterMaintenance.displayName = 'proto.acompanha.printer_maintenances.v1.PrinterMaintenance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.displayName = 'proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.displayName = 'proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.displayName = 'proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest.displayName = 'proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.displayName = 'proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.displayName = 'proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.displayName = 'proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.displayName = 'proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.displayName = 'proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest.displayName = 'proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.toObject = function(includeInstance, msg) {
  var f, obj = {
taskKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
label: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
intervalHours: jspb.Message.getFieldWithDefault(msg, 4, 0),
intervalDays: jspb.Message.getFieldWithDefault(msg, 5, 0),
neverPerformed: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
lastOccurredAt: (f = msg.getLastOccurredAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
referenceDate: (f = msg.getReferenceDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
daysSince: jspb.Message.getFieldWithDefault(msg, 9, 0),
wearHoursSince: jspb.Message.getFieldWithDefault(msg, 10, 0),
nextDueDate: (f = msg.getNextDueDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
daysRemaining: jspb.Message.getFieldWithDefault(msg, 12, 0),
hoursRemaining: jspb.Message.getFieldWithDefault(msg, 13, 0),
status: jspb.Message.getFieldWithDefault(msg, 14, ""),
dueBy: jspb.Message.getFieldWithDefault(msg, 15, ""),
suggestedHoursCount: jspb.Message.getFieldWithDefault(msg, 16, 0),
snoozedUntil: (f = msg.getSnoozedUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask;
  return proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntervalHours(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIntervalDays(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNeverPerformed(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastOccurredAt(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setReferenceDate(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDaysSince(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWearHoursSince(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNextDueDate(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDaysRemaining(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHoursRemaining(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setDueBy(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSuggestedHoursCount(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSnoozedUntil(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIntervalHours();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getIntervalDays();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getNeverPerformed();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getLastOccurredAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getReferenceDate();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDaysSince();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getWearHoursSince();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getNextDueDate();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDaysRemaining();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getHoursRemaining();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getDueBy();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSuggestedHoursCount();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getSnoozedUntil();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string task_key = 1;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getTaskKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setTaskKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 interval_hours = 4;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getIntervalHours = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setIntervalHours = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 interval_days = 5;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getIntervalDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setIntervalDays = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool never_performed = 6;
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getNeverPerformed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setNeverPerformed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp last_occurred_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getLastOccurredAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
*/
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setLastOccurredAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.clearLastOccurredAt = function() {
  return this.setLastOccurredAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.hasLastOccurredAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp reference_date = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getReferenceDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
*/
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setReferenceDate = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.clearReferenceDate = function() {
  return this.setReferenceDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.hasReferenceDate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 days_since = 9;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getDaysSince = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setDaysSince = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 wear_hours_since = 10;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getWearHoursSince = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setWearHoursSince = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp next_due_date = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getNextDueDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
*/
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setNextDueDate = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.clearNextDueDate = function() {
  return this.setNextDueDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.hasNextDueDate = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional int32 days_remaining = 12;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getDaysRemaining = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setDaysRemaining = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 hours_remaining = 13;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getHoursRemaining = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setHoursRemaining = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string status = 14;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string due_by = 15;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getDueBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setDueBy = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional int32 suggested_hours_count = 16;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getSuggestedHoursCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setSuggestedHoursCount = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional google.protobuf.Timestamp snoozed_until = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.getSnoozedUntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
*/
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.setSnoozedUntil = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.clearSnoozedUntil = function() {
  return this.setSnoozedUntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.prototype.hasSnoozedUntil = function() {
  return jspb.Message.getField(this, 17) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.toObject = function(includeInstance, msg) {
  var f, obj = {
printerUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
printerName: jspb.Message.getFieldWithDefault(msg, 2, ""),
brand: jspb.Message.getFieldWithDefault(msg, 3, ""),
model: jspb.Message.getFieldWithDefault(msg, 4, ""),
overdueCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
dueSoonCount: jspb.Message.getFieldWithDefault(msg, 6, 0),
tasksList: jspb.Message.toObjectList(msg.getTasksList(),
    proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.toObject, includeInstance),
snoozedCount: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter;
  return proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverdueCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDueSoonCount(value);
      break;
    case 7:
      var value = new proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask;
      reader.readMessage(value,proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.deserializeBinaryFromReader);
      msg.addTasks(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSnoozedCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrinterName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOverdueCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getDueSoonCount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getTasksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask.serializeBinaryToWriter
    );
  }
  f = message.getSnoozedCount();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional string printer_uuid = 1;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string printer_name = 2;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.getPrinterName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.setPrinterName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string brand = 3;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string model = 4;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.setModel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 overdue_count = 5;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.getOverdueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.setOverdueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 due_soon_count = 6;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.getDueSoonCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.setDueSoonCount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated UpcomingMaintenanceTask tasks = 7;
 * @return {!Array<!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask>}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.getTasksList = function() {
  return /** @type{!Array<!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask, 7));
};


/**
 * @param {!Array<!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask>} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter} returns this
*/
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.setTasksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.addTasks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.acompanha.printer_maintenances.v1.UpcomingMaintenanceTask, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.clearTasksList = function() {
  return this.setTasksList([]);
};


/**
 * optional int32 snoozed_count = 8;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.getSnoozedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter} returns this
 */
proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.prototype.setSnoozedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest;
  return proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
printersList: jspb.Message.toObjectList(msg.getPrintersList(),
    proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.toObject, includeInstance),
overdueTotal: jspb.Message.getFieldWithDefault(msg, 3, 0),
dueSoonTotal: jspb.Message.getFieldWithDefault(msg, 4, 0),
snoozedTotal: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse;
  return proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter;
      reader.readMessage(value,proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.deserializeBinaryFromReader);
      msg.addPrinters(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverdueTotal(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDueSoonTotal(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSnoozedTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPrintersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter.serializeBinaryToWriter
    );
  }
  f = message.getOverdueTotal();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDueSoonTotal();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSnoozedTotal();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated UpcomingMaintenancePrinter printers = 2;
 * @return {!Array<!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter>}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.getPrintersList = function() {
  return /** @type{!Array<!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter, 2));
};


/**
 * @param {!Array<!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter>} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse} returns this
*/
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.setPrintersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.addPrinters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.acompanha.printer_maintenances.v1.UpcomingMaintenancePrinter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.clearPrintersList = function() {
  return this.setPrintersList([]);
};


/**
 * optional int32 overdue_total = 3;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.getOverdueTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.setOverdueTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 due_soon_total = 4;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.getDueSoonTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.setDueSoonTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 snoozed_total = 5;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.getSnoozedTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.ListUpcomingMaintenancesResponse.prototype.setSnoozedTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
printerUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
taskKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
days: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest}
 */
proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest;
  return proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest}
 */
proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskKey(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDays();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string printer_uuid = 1;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string task_key = 2;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.prototype.getTaskKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.prototype.setTaskKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 days = 3;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.prototype.getDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.SnoozeMaintenanceTaskRequest.prototype.setDays = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
days: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest}
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest;
  return proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest}
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDays();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 days = 1;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest.prototype.getDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksRequest.prototype.setDays = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
snoozedUntil: (f = msg.getSnoozedUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
count: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse}
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse;
  return proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse}
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSnoozedUntil(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getSnoozedUntil();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp snoozed_until = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.prototype.getSnoozedUntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse} returns this
*/
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.prototype.setSnoozedUntil = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.prototype.clearSnoozedUntil = function() {
  return this.setSnoozedUntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.prototype.hasSnoozedUntil = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 count = 3;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.SnoozeAllMaintenanceTasksResponse.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
printerUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
taskKey: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest}
 */
proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest;
  return proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest}
 */
proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string printer_uuid = 1;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string task_key = 2;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.prototype.getTaskKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.ResumeMaintenanceTaskRequest.prototype.setTaskKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.ReplacementPart.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.ReplacementPart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.ReplacementPart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ReplacementPart.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
valueCents: jspb.Message.getFieldWithDefault(msg, 2, 0),
stockPartUuid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.ReplacementPart}
 */
proto.acompanha.printer_maintenances.v1.ReplacementPart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.ReplacementPart;
  return proto.acompanha.printer_maintenances.v1.ReplacementPart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.ReplacementPart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.ReplacementPart}
 */
proto.acompanha.printer_maintenances.v1.ReplacementPart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValueCents(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStockPartUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.ReplacementPart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.ReplacementPart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.ReplacementPart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ReplacementPart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValueCents();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getStockPartUuid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.ReplacementPart.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.ReplacementPart} returns this
 */
proto.acompanha.printer_maintenances.v1.ReplacementPart.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 value_cents = 2;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.ReplacementPart.prototype.getValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.ReplacementPart} returns this
 */
proto.acompanha.printer_maintenances.v1.ReplacementPart.prototype.setValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string stock_part_uuid = 3;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.ReplacementPart.prototype.getStockPartUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.ReplacementPart} returns this
 */
proto.acompanha.printer_maintenances.v1.ReplacementPart.prototype.setStockPartUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.PrinterMaintenance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
uuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
printerUuid: jspb.Message.getFieldWithDefault(msg, 3, ""),
occurredAt: (f = msg.getOccurredAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
type: jspb.Message.getFieldWithDefault(msg, 5, ""),
problemDescription: jspb.Message.getFieldWithDefault(msg, 6, ""),
analysisDurationMinutes: jspb.Message.getFieldWithDefault(msg, 7, 0),
performedActions: jspb.Message.getFieldWithDefault(msg, 8, ""),
printerHoursCount: jspb.Message.getFieldWithDefault(msg, 9, 0),
replacementPartsList: jspb.Message.toObjectList(msg.getReplacementPartsList(),
    proto.acompanha.printer_maintenances.v1.ReplacementPart.toObject, includeInstance),
correctionDurationMinutes: jspb.Message.getFieldWithDefault(msg, 11, 0),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.PrinterMaintenance;
  return proto.acompanha.printer_maintenances.v1.PrinterMaintenance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOccurredAt(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProblemDescription(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAnalysisDurationMinutes(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPerformedActions(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrinterHoursCount(value);
      break;
    case 10:
      var value = new proto.acompanha.printer_maintenances.v1.ReplacementPart;
      reader.readMessage(value,proto.acompanha.printer_maintenances.v1.ReplacementPart.deserializeBinaryFromReader);
      msg.addReplacementParts(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCorrectionDurationMinutes(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.PrinterMaintenance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOccurredAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProblemDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAnalysisDurationMinutes();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPerformedActions();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPrinterHoursCount();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getReplacementPartsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.acompanha.printer_maintenances.v1.ReplacementPart.serializeBinaryToWriter
    );
  }
  f = message.getCorrectionDurationMinutes();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string uuid = 2;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string printer_uuid = 3;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp occurred_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.getOccurredAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
*/
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.setOccurredAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.clearOccurredAt = function() {
  return this.setOccurredAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.hasOccurredAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string type = 5;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string problem_description = 6;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.getProblemDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.setProblemDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 analysis_duration_minutes = 7;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.getAnalysisDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.setAnalysisDurationMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string performed_actions = 8;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.getPerformedActions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.setPerformedActions = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 printer_hours_count = 9;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.getPrinterHoursCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.setPrinterHoursCount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * repeated ReplacementPart replacement_parts = 10;
 * @return {!Array<!proto.acompanha.printer_maintenances.v1.ReplacementPart>}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.getReplacementPartsList = function() {
  return /** @type{!Array<!proto.acompanha.printer_maintenances.v1.ReplacementPart>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printer_maintenances.v1.ReplacementPart, 10));
};


/**
 * @param {!Array<!proto.acompanha.printer_maintenances.v1.ReplacementPart>} value
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
*/
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.setReplacementPartsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.acompanha.printer_maintenances.v1.ReplacementPart=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printer_maintenances.v1.ReplacementPart}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.addReplacementParts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.acompanha.printer_maintenances.v1.ReplacementPart, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.clearReplacementPartsList = function() {
  return this.setReplacementPartsList([]);
};


/**
 * optional int32 correction_duration_minutes = 11;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.getCorrectionDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.setCorrectionDurationMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
*/
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
*/
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance} returns this
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenance.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
printerUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
type: jspb.Message.getFieldWithDefault(msg, 3, ""),
occurredFrom: (f = msg.getOccurredFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
occurredTo: (f = msg.getOccurredTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest;
  return proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOccurredFrom(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOccurredTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOccurredFrom();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOccurredTo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} returns this
*/
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string printer_uuid = 2;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp occurred_from = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.getOccurredFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} returns this
*/
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.setOccurredFrom = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.clearOccurredFrom = function() {
  return this.setOccurredFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.hasOccurredFrom = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp occurred_to = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.getOccurredTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} returns this
*/
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.setOccurredTo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.clearOccurredTo = function() {
  return this.setOccurredTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest.prototype.hasOccurredTo = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
printerUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
type: jspb.Message.getFieldWithDefault(msg, 3, ""),
occurredFrom: (f = msg.getOccurredFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
occurredTo: (f = msg.getOccurredTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest;
  return proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOccurredFrom(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOccurredTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOccurredFrom();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOccurredTo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string printer_uuid = 1;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 2;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} returns this
*/
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp occurred_from = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.getOccurredFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} returns this
*/
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.setOccurredFrom = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.clearOccurredFrom = function() {
  return this.setOccurredFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.hasOccurredFrom = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp occurred_to = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.getOccurredTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} returns this
*/
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.setOccurredTo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.clearOccurredTo = function() {
  return this.setOccurredTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest.prototype.hasOccurredTo = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
maintenancesList: jspb.Message.toObjectList(msg.getMaintenancesList(),
    proto.acompanha.printer_maintenances.v1.PrinterMaintenance.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse;
  return proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.printer_maintenances.v1.PrinterMaintenance;
      reader.readMessage(value,proto.acompanha.printer_maintenances.v1.PrinterMaintenance.deserializeBinaryFromReader);
      msg.addMaintenances(value);
      break;
    case 3:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMaintenancesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.acompanha.printer_maintenances.v1.PrinterMaintenance.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated PrinterMaintenance maintenances = 2;
 * @return {!Array<!proto.acompanha.printer_maintenances.v1.PrinterMaintenance>}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.prototype.getMaintenancesList = function() {
  return /** @type{!Array<!proto.acompanha.printer_maintenances.v1.PrinterMaintenance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printer_maintenances.v1.PrinterMaintenance, 2));
};


/**
 * @param {!Array<!proto.acompanha.printer_maintenances.v1.PrinterMaintenance>} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse} returns this
*/
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.prototype.setMaintenancesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printer_maintenances.v1.PrinterMaintenance}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.prototype.addMaintenances = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.acompanha.printer_maintenances.v1.PrinterMaintenance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.prototype.clearMaintenancesList = function() {
  return this.setMaintenancesList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 3;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 3));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse} returns this
*/
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest}
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest;
  return proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest}
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
data: (f = msg.getData()) && proto.acompanha.printer_maintenances.v1.PrinterMaintenance.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse}
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse;
  return proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse}
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.printer_maintenances.v1.PrinterMaintenance;
      reader.readMessage(value,proto.acompanha.printer_maintenances.v1.PrinterMaintenance.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.printer_maintenances.v1.PrinterMaintenance.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional PrinterMaintenance data = 2;
 * @return {?proto.acompanha.printer_maintenances.v1.PrinterMaintenance}
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.printer_maintenances.v1.PrinterMaintenance} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.printer_maintenances.v1.PrinterMaintenance, 2));
};


/**
 * @param {?proto.acompanha.printer_maintenances.v1.PrinterMaintenance|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse} returns this
*/
proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
printerUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, ""),
problemDescription: jspb.Message.getFieldWithDefault(msg, 3, ""),
occurredAt: (f = msg.getOccurredAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
analysisDurationMinutes: jspb.Message.getFieldWithDefault(msg, 5, 0),
performedActions: jspb.Message.getFieldWithDefault(msg, 6, ""),
printerHoursCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
replacementPartsList: jspb.Message.toObjectList(msg.getReplacementPartsList(),
    proto.acompanha.printer_maintenances.v1.ReplacementPart.toObject, includeInstance),
correctionDurationMinutes: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest;
  return proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProblemDescription(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOccurredAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAnalysisDurationMinutes(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPerformedActions(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrinterHoursCount(value);
      break;
    case 8:
      var value = new proto.acompanha.printer_maintenances.v1.ReplacementPart;
      reader.readMessage(value,proto.acompanha.printer_maintenances.v1.ReplacementPart.deserializeBinaryFromReader);
      msg.addReplacementParts(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCorrectionDurationMinutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProblemDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOccurredAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAnalysisDurationMinutes();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPerformedActions();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPrinterHoursCount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getReplacementPartsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.acompanha.printer_maintenances.v1.ReplacementPart.serializeBinaryToWriter
    );
  }
  f = message.getCorrectionDurationMinutes();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string printer_uuid = 1;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string problem_description = 3;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.getProblemDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.setProblemDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp occurred_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.getOccurredAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} returns this
*/
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.setOccurredAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.clearOccurredAt = function() {
  return this.setOccurredAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.hasOccurredAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int32 analysis_duration_minutes = 5;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.getAnalysisDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.setAnalysisDurationMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string performed_actions = 6;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.getPerformedActions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.setPerformedActions = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 printer_hours_count = 7;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.getPrinterHoursCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.setPrinterHoursCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated ReplacementPart replacement_parts = 8;
 * @return {!Array<!proto.acompanha.printer_maintenances.v1.ReplacementPart>}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.getReplacementPartsList = function() {
  return /** @type{!Array<!proto.acompanha.printer_maintenances.v1.ReplacementPart>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printer_maintenances.v1.ReplacementPart, 8));
};


/**
 * @param {!Array<!proto.acompanha.printer_maintenances.v1.ReplacementPart>} value
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} returns this
*/
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.setReplacementPartsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.acompanha.printer_maintenances.v1.ReplacementPart=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printer_maintenances.v1.ReplacementPart}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.addReplacementParts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.acompanha.printer_maintenances.v1.ReplacementPart, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.clearReplacementPartsList = function() {
  return this.setReplacementPartsList([]);
};


/**
 * optional int32 correction_duration_minutes = 9;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.getCorrectionDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest.prototype.setCorrectionDurationMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
data: (f = msg.getData()) && proto.acompanha.printer_maintenances.v1.PrinterMaintenance.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse;
  return proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.printer_maintenances.v1.PrinterMaintenance;
      reader.readMessage(value,proto.acompanha.printer_maintenances.v1.PrinterMaintenance.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.printer_maintenances.v1.PrinterMaintenance.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional PrinterMaintenance data = 2;
 * @return {?proto.acompanha.printer_maintenances.v1.PrinterMaintenance}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.printer_maintenances.v1.PrinterMaintenance} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.printer_maintenances.v1.PrinterMaintenance, 2));
};


/**
 * @param {?proto.acompanha.printer_maintenances.v1.PrinterMaintenance|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse} returns this
*/
proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
printerUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
type: jspb.Message.getFieldWithDefault(msg, 3, ""),
problemDescription: jspb.Message.getFieldWithDefault(msg, 4, ""),
occurredAt: (f = msg.getOccurredAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
analysisDurationMinutes: jspb.Message.getFieldWithDefault(msg, 6, 0),
performedActions: jspb.Message.getFieldWithDefault(msg, 7, ""),
printerHoursCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
replacementPartsList: jspb.Message.toObjectList(msg.getReplacementPartsList(),
    proto.acompanha.printer_maintenances.v1.ReplacementPart.toObject, includeInstance),
correctionDurationMinutes: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest;
  return proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProblemDescription(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOccurredAt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAnalysisDurationMinutes(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPerformedActions(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrinterHoursCount(value);
      break;
    case 9:
      var value = new proto.acompanha.printer_maintenances.v1.ReplacementPart;
      reader.readMessage(value,proto.acompanha.printer_maintenances.v1.ReplacementPart.deserializeBinaryFromReader);
      msg.addReplacementParts(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCorrectionDurationMinutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProblemDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOccurredAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAnalysisDurationMinutes();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getPerformedActions();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPrinterHoursCount();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getReplacementPartsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.acompanha.printer_maintenances.v1.ReplacementPart.serializeBinaryToWriter
    );
  }
  f = message.getCorrectionDurationMinutes();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string printer_uuid = 2;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string problem_description = 4;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.getProblemDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.setProblemDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp occurred_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.getOccurredAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} returns this
*/
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.setOccurredAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.clearOccurredAt = function() {
  return this.setOccurredAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.hasOccurredAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 analysis_duration_minutes = 6;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.getAnalysisDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.setAnalysisDurationMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string performed_actions = 7;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.getPerformedActions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.setPerformedActions = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int32 printer_hours_count = 8;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.getPrinterHoursCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.setPrinterHoursCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated ReplacementPart replacement_parts = 9;
 * @return {!Array<!proto.acompanha.printer_maintenances.v1.ReplacementPart>}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.getReplacementPartsList = function() {
  return /** @type{!Array<!proto.acompanha.printer_maintenances.v1.ReplacementPart>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.printer_maintenances.v1.ReplacementPart, 9));
};


/**
 * @param {!Array<!proto.acompanha.printer_maintenances.v1.ReplacementPart>} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} returns this
*/
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.setReplacementPartsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.acompanha.printer_maintenances.v1.ReplacementPart=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.printer_maintenances.v1.ReplacementPart}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.addReplacementParts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.acompanha.printer_maintenances.v1.ReplacementPart, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.clearReplacementPartsList = function() {
  return this.setReplacementPartsList([]);
};


/**
 * optional int32 correction_duration_minutes = 10;
 * @return {number}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.getCorrectionDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest.prototype.setCorrectionDurationMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
data: (f = msg.getData()) && proto.acompanha.printer_maintenances.v1.PrinterMaintenance.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse;
  return proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 2:
      var value = new proto.acompanha.printer_maintenances.v1.PrinterMaintenance;
      reader.readMessage(value,proto.acompanha.printer_maintenances.v1.PrinterMaintenance.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.printer_maintenances.v1.PrinterMaintenance.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional PrinterMaintenance data = 2;
 * @return {?proto.acompanha.printer_maintenances.v1.PrinterMaintenance}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.printer_maintenances.v1.PrinterMaintenance} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.printer_maintenances.v1.PrinterMaintenance, 2));
};


/**
 * @param {?proto.acompanha.printer_maintenances.v1.PrinterMaintenance|undefined} value
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse} returns this
*/
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse} returns this
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest}
 */
proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest;
  return proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest}
 */
proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest} returns this
 */
proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.acompanha.printer_maintenances.v1);
